import * as React from 'react';
import { ISelectableTile , ISelectableTileData } from '../../../../interfaces/KPSelectableTile/KPSelectableTileInterfaces';
import KPSelectableTile from './KPSelectableTile';

class KPSelectableTileContainer extends React.Component<ISelectableTileData, any>{
    constructor(props) {
        super(props)

        this.state = {
            items : this.props.items ?? []
        }
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(id, selected) {
        let items = [...this.state.items];

        if (this.props.radioGroup && selected) {
            items.filter(x => x.id !== id).forEach(item => { item.selected = false; });
            items.filter(x => x.id === id).forEach(item => { item.selected = true; });  // Can only deselect by selecting another item from group.
        }
        else if (!this.props.radioGroup) {
            items.filter(x => x.id == id).forEach(item => { item.selected = selected; });
        }

        this.setState({ items });

        if (this.props.handleSelect) {
            this.props.handleSelect(id, selected);
        }
    }

    setList(items: ISelectableTile[]) {
        this.setState({ items });
    }

    getList(): ISelectableTile[] {
        return [...this.state.items];
    }

    getSelection(): ISelectableTile[] {
        return this.state.items.filter(x => x.selected);
    }

    public render() {

        let items: any = <></>
        if (this.state.items && this.state.items.length > 0) {
            items = this.state.items.map((item, index) => {
                return <KPSelectableTile
                    key={index}
                    id={item.id}
                    title={item.title}
                    body={item.body}
                    tileImage={item.tileImage}
                    value={item.value}
                    className={item.className + (this.props.radioGroup ? " radioGroup" : " checkboxGroup")}
                    selected={item.selected}
                    handleSelect={this.handleSelect}
                    colClassName={item.colClassName}
                />
            });
        }
        return (
            <div className="row">
                {items}
            </div>
        ) 

    }
}

export default KPSelectableTileContainer